import axios from 'axios';
import { Event } from 'services/events';
import getApiError from 'services/getApiError';
import useSWR from 'swr';

export const getEventDetails = async (eventId: string) => {
  const response = await axios.get<Event>(
    `${process.env.REACT_APP_EVENT_HOST}/${eventId}/data/event.json`
  );

  return response?.data;
};

const useEventDetails = (eventId?: string) => {
  const { data, error, isValidating } = useSWR(
    eventId ? `workshop_event_details/${eventId}` : null,
    () => (eventId ? getEventDetails(eventId) : null)
  );

  const isLoading = isValidating && !data && !error;

  return {
    isLoading,
    eventDetails: data,
    error: getApiError(error)
  };
};

export default useEventDetails;
